import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, pipe } from 'rxjs';
import { JsonPipe } from '@angular/common';
import { map } from 'rxjs/operators';
import { ConstantsService } from '../Constants/constants.service';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  invokeEvent: Subject<any> = new Subject();
  private service_URL: any;
  public headersData: any;

  constructor(private http: HttpClient) {
    this.service_URL = ConstantsService;
  }

  // SecurePassToken<T>() : any {

  //     let headers = new HttpHeaders(); 
  //     headers.append('Content-Type', 'application/json');
  //     headers.append('Accept', 'application/json');
  //     headers.append('Access-Control-Allow-Origin', '*');
  //     headers.append('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE');
  //     headers.append('Access-Control-Allow-Headers', 'Content-Type');      


  //     return this.http.post(this.service_URL.Auth.getToken, { headers: headers})
  //     .pipe(    
  //         data => data,
  //         error => error,
  //       )  
  //   }

  registerTest(): Observable<any> {

    let tokenNew = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${tokenNew}`
    })

    return this.http.get(this.service_URL.Auth.getTestApi, {
      headers: headers
    })
      .pipe(
        map((res) => {
          return res;
        }))

  }

  GetHttpHeader() {

    let tokenNew = localStorage.getItem('accessToken');
    //console.warn(tokenNew)
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${tokenNew}`,

       //'Access-Control-Allow-Origin': '*',
      //'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
     // 'Access-Control-Allow-Headers': 'Content-Type'
    });

  }

  GetHeader() {

    let tokenNew = localStorage.getItem('accessToken');

    return new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${tokenNew}`,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
      'Access-Control-Allow-Headers': 'Content-Type'
    });

  }

  GetUserDetails() {
     localStorage.setItem('UserRole', window["userRole"].value);
     localStorage.setItem('UserAlias', window["userAlias"].value);
     localStorage.setItem('UserName', window["userName"].value);
     localStorage.setItem('UserCity', window["userCity"].value);
    //  localStorage.setItem('UserOffice', window["userOffice"].value);    
  }
  SessionTimeout() { 
    this.invokeEvent.next(null);      
  }

}
